import { Badge } from "@/components/ui/badge";
import { ShieldCheck, Building2, ShieldQuestion } from "lucide-react";

const CONFIG = {
  verified: {
    label: "Verified",
    icon: ShieldCheck,
    cls: "bg-[hsl(174,38%,92%)] text-[hsl(174,45%,18%)] border-[hsl(174,38%,60%)]",
  },
  agency: {
    label: "Agency-represented",
    icon: Building2,
    cls: "bg-[hsl(28,55%,93%)] text-[hsl(28,55%,25%)] border-[hsl(28,55%,65%)]",
  },
  unverified: {
    label: "Unverified",
    icon: ShieldQuestion,
    cls: "bg-[hsl(30,18%,94%)] text-[hsl(20,8%,42%)] border-[hsl(28,14%,80%)]",
  },
};

export const TrustBadge = ({ trust, className = "" }) => {
  const cfg = CONFIG[trust] || CONFIG.unverified;
  const Icon = cfg.icon;
  return (
    <Badge
      data-testid={`trust-badge-${trust || "unverified"}`}
      variant="outline"
      className={`rounded-full gap-1 px-2 py-0.5 text-[10px] font-semibold tracking-wide ${cfg.cls} ${className}`}
    >
      <Icon className="h-3 w-3" /> {cfg.label}
    </Badge>
  );
};
